export function SelectOnClickDirective() {
  return function (scope, element, attrs) {
    element.bind('click', function () {
      this.select();
    });
  };
}
